module.exports = __webpack_public_path__ + "img/em-energymonitor-studies-03.6563a1ee.jpeg";